import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import FooterTwo from '../components/Footer/FooterTwo';
import FooterData from '../components/Footer/FooterData';
const NotFound = () => (
  <div className="body_wrapper">
    <CustomNavbar hbtnClass="new_btn" />
    <section className="error_two_area">
      <div className="container flex">
        <div className="error_content_two text-center">
          <img width="50%" src={require("../img/new/error.png")} alt="" />
          <h3 className="hemdahl-text-dark m-4">We can’t find the page you’re looking for.</h3>
          <p>
            Sorry for the inconvenience.{" "}
          </p>
          <a href="/" className="btn_get btn_hover new_btn p-2">
            Back to Home Page <i className="arrow_right"></i>
          </a>
        </div>
      </div>
    </section>
    <FooterTwo FooterData={FooterData} />
  </div>
);
export default NotFound;
